export const GREEN = '#2B5339';
export const RUST = '#C05C35';
export const MUTED = '#5C6B61';


export const fmtRate = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmt0 = (n) => Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });
export const fmt2 = (n) => Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });


export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return iso; }
};


export const downloadBlob = (res, fallbackName) => {
  const disp = res.headers?.['content-disposition'] || '';
  const m = disp.match(/filename=([^;]+)/);
  const name = m ? m[1].trim().replace(/"/g, '') : fallbackName;
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};


// Tiny inline SVG sparkline from an array of numbers.
export const Sparkline = ({ values, width = 72, height = 22, color = GREEN }) => {
  const vals = (values || []).map((v) => Number(v) || 0);
  if (vals.length === 0) return <span style={{ color: MUTED, fontSize: 11 }}>—</span>;
  if (vals.length === 1) {
    return (
      <svg width={width} height={height}>
        <circle cx={width / 2} cy={height / 2} r="2.5" fill={color} />
      </svg>
    );
  }
  const min = Math.min(...vals);
  const max = Math.max(...vals);
  const span = max - min || 1;
  const stepX = width / (vals.length - 1);
  const pts = vals.map((v, i) => {
    const x = i * stepX;
    const y = height - 3 - ((v - min) / span) * (height - 6);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });
  const up = vals[vals.length - 1] >= vals[0];
  const stroke = up ? RUST : GREEN; // rising cost = rust (warning)
  return (
    <svg width={width} height={height} style={{ overflow: 'visible' }}>
      <polyline points={pts.join(' ')} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={(vals.length - 1) * stepX} cy={height - 3 - ((vals[vals.length - 1] - min) / span) * (height - 6)} r="2" fill={stroke} />
    </svg>
  );
};
